import { render, staticRenderFns } from "./TimelineCampanhas.vue?vue&type=template&id=488b5dbc&scoped=true&"
import script from "./TimelineCampanhas.vue?vue&type=script&lang=js&"
export * from "./TimelineCampanhas.vue?vue&type=script&lang=js&"
import style0 from "./TimelineCampanhas.vue?vue&type=style&index=0&id=488b5dbc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "488b5dbc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VOverlay } from 'vuetify/lib/components/VOverlay';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VOverlay,VProgressCircular})
